import Breadcrumb from "../../components/breadcrumbs/Breadcrumb.vue";
import TextField from "../../components/fields/textField/TextField.vue";
import { ConfiguracaoService } from "../../services/ConfiguracaoService";

export default {
    name: "GerenciamentoTabelasBasicas",
    components: {
        Breadcrumb,
        TextField
    },
    data: () => ({
        breadcrumbs: [
            {
                text: 'Página Inicial',
                disabled: false,
                href: '/',
            },
            {
                text: 'Gerenciamento de Entidades',
                disabled: true
            }
        ],
        selectedEntityIndex: 0, // Ação selecionada por padrão
        expandedSections: {
            exercicio: true,
            acao: true,
            subacao: false,
            funcao: false,
            subfuncao: false,
            outros: true
        },
        configuracoes: {},
        entities: [
            {
                name: 'Ação',
                pai: 'acao',
                icon: 'mdi-account',
                fields: [
                    { label: 'Ano Exercício', id: 'ano-exercicio', model: '', rules: [(v) => !!v || `Preencha o campo corretamente`], responsive: { lg: 6, md: 6, sm: 12, cols: 12 }, group: 'exercicio' },
                    { label: 'Ação - Código', id: 'projeto-atividade-codigo', model: '', rules: [(v) => !!v || `Preencha o campo corretamente`], responsive: { lg: 6, md: 6, sm: 12, cols: 12 }, group: 'acao' },
                    { label: 'Ação - Descrição', id: 'projeto-atividade-descricao', model: '', rules: [(v) => !!v || `Preencha o campo corretamente`], responsive: { lg: 6, md: 6, sm: 12, cols: 12 }, group: 'acao' },
                    { label: 'Sub Ação - Código', id: 'subprojeto-subatividade-codigo', model: '', rules: [(v) => !!v || `Preencha o campo corretamente`], responsive: { lg: 6, md: 6, sm: 12, cols: 12 }, group: 'subacao' },
                    { label: 'Sub Ação - Descrição', id: 'subprojeto-subatividade-descricao', model: '', rules: [(v) => !!v || `Preencha o campo corretamente`], responsive: { lg: 6, md: 6, sm: 12, cols: 12 }, group: 'subacao' },
                    { label: 'Função - Código', id: 'funcao-codigo', model: '', rules: [(v) => !!v || `Preencha o campo corretamente`], responsive: { lg: 6, md: 6, sm: 12, cols: 12 }, group: 'funcao' },
                    { label: 'Função - Descrição', id: 'funcao-descricao', model: '', rules: [(v) => !!v || `Preencha o campo corretamente`], responsive: { lg: 6, md: 6, sm: 12, cols: 12 }, group: 'funcao' },
                    { label: 'Subfunção - Código', id: 'subfuncao-codigo', model: '', rules: [(v) => !!v || `Preencha o campo corretamente`], responsive: { lg: 6, md: 6, sm: 12, cols: 12 }, group: 'subfuncao' },
                    { label: 'Subfunção - Descrição', id: 'subfuncao-descricao', model: '', rules: [(v) => !!v || `Preencha o campo corretamente`], responsive: { lg: 6, md: 6, sm: 12, cols: 12 }, group: 'subfuncao' },
                ]
            },
            {
                name: 'Elemento',
                pai: 'elemento',
                icon: 'mdi-folder',
                fields: [
                    { label: 'Ano Exercício', id: 'ano-exercicio-natureza-desp-destino', model: '', rules: [(v) => !!v || `Preencha o campo corretamente`], responsive: { lg: 6, md: 6, sm: 12, cols: 12 }, group: 'exercicio' },
                    { label: 'Elemento - Código', id: 'elemento-despesa-destino-codigo', model: '', rules: [(v) => !!v || `Preencha o campo corretamente`], responsive: { lg: 6, md: 6, sm: 12, cols: 12 }, group: 'outros' },
                    { label: 'Elemento - Descrição', id: 'elemento-despesa-destino-descricao', model: '', rules: [(v) => !!v || `Preencha o campo corretamente`], responsive: { lg: 6, md: 6, sm: 12, cols: 12 }, group: 'outros' },
                ]
            },
            {
                name: 'Elemento Item',
                pai: 'elemento-item',
                icon: 'mdi-shopping',
                fields: [
                    { label: 'Ano Exercício', id: 'ano-exercicio-natureza-desp-destino', model: '', rules: [(v) => !!v || `Preencha o campo corretamente`], responsive: { lg: 6, md: 6, sm: 12, cols: 12 }, group: 'exercicio' },
                    { label: 'Elemento Item - Código', id: 'elemento-item-despesa-origem-codigo', model: '', rules: [(v) => !!v || `Preencha o campo corretamente`], responsive: { lg: 6, md: 6, sm: 12, cols: 12 }, group: 'outros' },
                    { label: 'Elemento Item - Descrição', id: 'elemento-item-despesa-origem-descricao', model: '', rules: [(v) => !!v || `Preencha o campo corretamente`], responsive: { lg: 6, md: 6, sm: 12, cols: 12 }, group: 'outros' },
                ]
            },
            {
                name: 'Fonte',
                pai: 'fonte',
                icon: 'mdi-file',
                fields: [
                    { label: 'Ano Exercício', id: 'ano-exercicio-gmifp', model: '', rules: [(v) => !!v || `Preencha o campo corretamente`], responsive: { lg: 6, md: 6, sm: 12, cols: 12 }, group: 'exercicio' },
                    { label: 'Fonte - Código', id: 'fonte-recurso-codigo', model: '', rules: [(v) => !!v || `Preencha o campo corretamente`], responsive: { lg: 6, md: 6, sm: 12, cols: 12 }, group: 'outros' },
                    { label: 'Fonte - Descrição', id: 'fonte-recurso-descricao', model: '', rules: [(v) => !!v || `Preencha o campo corretamente`], responsive: { lg: 6, md: 6, sm: 12, cols: 12 }, group: 'outros' },
                ]
            },
            {
                name: 'Grupo',
                pai: 'grupo',
                icon: 'mdi-account-group',
                fields: [
                    { label: 'Ano Exercício', id: 'ano-exercicio-gmifp', model: '', rules: [(v) => !!v || `Preencha o campo corretamente`], responsive: { lg: 6, md: 6, sm: 12, cols: 12 }, group: 'exercicio' },
                    { label: 'Grupo - Código Transação', id: 'grupo-despesa-codigo', model: '', rules: [(v) => !!v || `Preencha o campo corretamente`], responsive: { lg: 6, md: 6, sm: 12, cols: 12 }, group: 'outros' },
                    { label: 'Grupo - Descrição', id: 'grupo-despesa-descricao', model: '', rules: [(v) => !!v || `Preencha o campo corretamente`], responsive: { lg: 6, md: 6, sm: 12, cols: 12 }, group: 'outros' },
                ]
            },
            {
                name: 'IPG',
                pai: 'ipg',
                icon: 'mdi-account-check',
                fields: [
                    { label: 'Exercício', id: 'ano-exercicio-gmifp', model: '', rules: [(v) => !!v || `Preencha o campo corretamente`], responsive: { lg: 6, md: 6, sm: 12, cols: 12 }, group: 'exercicio' },
                    { label: 'IPG - Código', id: 'identificador-orcamento-codigo', model: '', rules: [(v) => !!v || `Preencha o campo corretamente`], responsive: { lg: 6, md: 6, sm: 12, cols: 12 }, group: 'outros' },
                    { label: 'IPG - Descrição', id: 'identificador-orcamento-descricao', model: '', rules: [(v) => !!v || `Preencha o campo corretamente`], responsive: { lg: 6, md: 6, sm: 12, cols: 12 }, group: 'outros' },
                ]
            },
            {
                name: 'IPU',
                pai: 'ipu',
                icon: 'mdi-account-off',
                fields: [
                    { label: 'Ano Exercício', id: 'ano-exercicio-gmifp', model: '', rules: [(v) => !!v || `Preencha o campo corretamente`], responsive: { lg: 6, md: 6, sm: 12, cols: 12 }, group: 'exercicio' },
                    { label: 'IPU - Código', id: 'procedencia-codigo', model: '', rules: [(v) => !!v || `Preencha o campo corretamente`], responsive: { lg: 6, md: 6, sm: 12, cols: 12 }, group: 'outros' },
                    { label: 'IPU - Descrição', id: 'procedencia-descricao', model: '', rules: [(v) => !!v || `Preencha o campo corretamente`], responsive: { lg: 6, md: 6, sm: 12, cols: 12 }, group: 'outros' },
                ]
            },
            {
                name: 'Programa',
                pai: 'programa',
                icon: 'mdi-book',
                fields: [
                    { label: 'Ano Exercício', id: 'ano-exercicio-programa-trabalho', model: '', rules: [(v) => !!v || `Preencha o campo corretamente`], responsive: { lg: 6, md: 6, sm: 12, cols: 12 }, group: 'exercicio' },
                    { label: 'Programa - Código', id: 'programa-codigo', model: '', rules: [(v) => !!v || `Preencha o campo corretamente`], responsive: { lg: 6, md: 6, sm: 12, cols: 12 }, group: 'outros' },
                    { label: 'Programa - Descrição', id: 'programa-descricao', model: '', rules: [(v) => !!v || `Preencha o campo corretamente`], responsive: { lg: 6, md: 6, sm: 12, cols: 12 }, group: 'outros' },
                ]
            },
            {
                name: 'Unidade Execução',
                pai: 'unidade-executora',
                icon: 'mdi-domain',
                fields: [
                    { label: 'Ano Exercício', id: 'ano-exercicio-unidade-executora', model: '', rules: [(v) => !!v || `Preencha o campo corretamente`], responsive: { lg: 6, md: 6, sm: 12, cols: 12 }, group: 'exercicio' },
                    { label: 'Unidade Executora - Código', id: 'unidade-executora-codigo', model: '', rules: [(v) => !!v || `Preencha o campo corretamente`], responsive: { lg: 6, md: 6, sm: 12, cols: 12 }, group: 'outros' },
                    { label: 'Unidade Executora - Nome', id: 'unidade-executora-nome', model: '', rules: [(v) => !!v || `Preencha o campo corretamente`], responsive: { lg: 6, md: 6, sm: 12, cols: 12 }, group: 'outros' },
                ]
            },
            {
                name: 'Unidade Orçamentária',
                pai: 'unidade-orcamentaria',
                icon: 'mdi-bank',
                fields: [
                    { label: 'Ano Exercício', id: 'ano-exercicio-unidade-orcamentaria', model: '', rules: [(v) => !!v || `Preencha o campo corretamente`], responsive: { lg: 6, md: 6, sm: 12, cols: 12 }, group: 'exercicio' },
                    { label: 'Unidade Orçamentária - Código', id: 'unidade-orcamentaria-codigo', model: '', rules: [(v) => !!v || `Preencha o campo corretamente`], responsive: { lg: 6, md: 6, sm: 12, cols: 12 }, group: 'outros' },
                    { label: 'Unidade Orçamentária - Nome', id: 'unidade-orcamentaria-nome', model: '', rules: [(v) => !!v || `Preencha o campo corretamente`], responsive: { lg: 6, md: 6, sm: 12, cols: 12 }, group: 'outros' },
                ]
            }
        ]
    }),
    created() {
        this.buscaConfiguracoesIniciais();
    },
    computed: {
        sortedEntities() {
            return this.entities.slice().sort((a, b) => a.name.localeCompare(b.name));
        },
        selectedEntity() {
            return this.sortedEntities[this.selectedEntityIndex] || this.sortedEntities[0];
        }
    },
    watch: {
        configuracoes: {
            handler: function (newConfiguracoes) {
                // Mantém a lógica original de atualização das configurações
                if (newConfiguracoes && newConfiguracoes.length > 0) {
                    this.entities[0].fields[0].model = newConfiguracoes[0].colunas[0].campo_planilha;
                    this.entities[0].fields[1].model = newConfiguracoes[0].colunas[1].campo_planilha;
                    this.entities[0].fields[2].model = newConfiguracoes[0].colunas[2].campo_planilha;
                    this.entities[0].fields[3].model = newConfiguracoes[0].colunas[3].campo_planilha;
                    this.entities[0].fields[4].model = newConfiguracoes[0].colunas[4].campo_planilha;
                    this.entities[0].fields[5].model = newConfiguracoes[0].colunas[5].campo_planilha;
                    this.entities[0].fields[6].model = newConfiguracoes[0].colunas[6].campo_planilha;
                    this.entities[0].fields[7].model = newConfiguracoes[0].colunas[7].campo_planilha;
                    this.entities[0].fields[8].model = newConfiguracoes[0].colunas[8].campo_planilha;

                    this.entities[1].fields[0].model = newConfiguracoes[1].colunas[0].campo_planilha;
                    this.entities[1].fields[1].model = newConfiguracoes[1].colunas[1].campo_planilha;
                    this.entities[1].fields[2].model = newConfiguracoes[1].colunas[2].campo_planilha;

                    this.entities[2].fields[0].model = newConfiguracoes[2].colunas[0].campo_planilha;
                    this.entities[2].fields[1].model = newConfiguracoes[2].colunas[1].campo_planilha;
                    this.entities[2].fields[2].model = newConfiguracoes[2].colunas[2].campo_planilha;

                    this.entities[3].fields[0].model = newConfiguracoes[3].colunas[0].campo_planilha;
                    this.entities[3].fields[1].model = newConfiguracoes[3].colunas[1].campo_planilha;
                    this.entities[3].fields[2].model = newConfiguracoes[3].colunas[2].campo_planilha;

                    this.entities[4].fields[0].model = newConfiguracoes[4].colunas[0].campo_planilha;
                    this.entities[4].fields[1].model = newConfiguracoes[4].colunas[1].campo_planilha;
                    this.entities[4].fields[2].model = newConfiguracoes[4].colunas[2].campo_planilha;

                    this.entities[5].fields[0].model = newConfiguracoes[5].colunas[0].campo_planilha;
                    this.entities[5].fields[1].model = newConfiguracoes[5].colunas[1].campo_planilha;
                    this.entities[5].fields[2].model = newConfiguracoes[5].colunas[2].campo_planilha;

                    this.entities[6].fields[0].model = newConfiguracoes[6].colunas[0].campo_planilha;
                    this.entities[6].fields[1].model = newConfiguracoes[6].colunas[1].campo_planilha;
                    this.entities[6].fields[2].model = newConfiguracoes[6].colunas[2].campo_planilha;

                    this.entities[7].fields[0].model = newConfiguracoes[7].colunas[0].campo_planilha;
                    this.entities[7].fields[1].model = newConfiguracoes[7].colunas[1].campo_planilha;
                    this.entities[7].fields[2].model = newConfiguracoes[7].colunas[2].campo_planilha;

                    this.entities[8].fields[0].model = newConfiguracoes[8].colunas[0].campo_planilha;
                    this.entities[8].fields[1].model = newConfiguracoes[8].colunas[1].campo_planilha;
                    this.entities[8].fields[2].model = newConfiguracoes[8].colunas[2].campo_planilha;

                    this.entities[9].fields[0].model = newConfiguracoes[9].colunas[0].campo_planilha;
                    this.entities[9].fields[1].model = newConfiguracoes[9].colunas[1].campo_planilha;
                    this.entities[9].fields[2].model = newConfiguracoes[9].colunas[2].campo_planilha;
                }
            }
        },
    },
    methods: {
        selectEntity(index) {
            this.selectedEntityIndex = index;
            // Reset expanded sections when changing entity
            this.expandedSections = {
                exercicio: true,
                acao: this.selectedEntity.name === 'Ação',
                subacao: false,
                funcao: false,
                subfuncao: false,
                outros: this.selectedEntity.name !== 'Ação'
            };
        },
        toggleSection(sectionName) {
            this.expandedSections[sectionName] = !this.expandedSections[sectionName];
            
            // Adiciona classe CSS para fallback em navegadores antigos
            this.$nextTick(() => {
                const sections = document.querySelectorAll('.form-section');
                sections.forEach((section, index) => {
                    const sectionNames = ['exercicio', 'acao', 'subacao', 'funcao', 'subfuncao', 'outros'];
                    const currentSection = sectionNames[index];
                    if (this.expandedSections[currentSection]) {
                        section.classList.add('expanded');
                    } else {
                        section.classList.remove('expanded');
                    }
                });
            });
        },
        getFieldsByGroup(groupName) {
            return this.selectedEntity.fields.filter(field => field.group === groupName);
        },
        async save() {
            console.log('Salvar');
            try {
                const formData = new FormData();

                this.entities.forEach(entity => {
                    const entityData = {
                        name: entity.pai,
                        fields: {}
                    };

                    entity.fields.forEach(field => {
                        entityData.fields[field.id] = field.model;
                    });

                    formData.append(entity.pai, JSON.stringify(entityData));
                });

                await ConfiguracaoService.store(formData);

            } catch (error) {
                console.error("Erro ao salvar as configurações:", error);
            }
        },
        gerenciarCargas() {
            console.log('Gerenciar Cargas');
            this.$router.push('/gerenciar-tabelas-cargas');
        },
        async buscaConfiguracoesIniciais() {
            try {
                const response = await ConfiguracaoService.show();
                if (response) {
                    this.configuracoes = response.data
                } else {
                    console.error('Não foi possível obter as configurações.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao obter as configurações:', error);
            }
        }
    }
};